import React, { useState, useEffect, useRef } from "react";

const fmt = totalSecs => {
  const m = Math.floor(totalSecs / 60)
    .toString()
    .padStart(2, "0");
  const s = Math.floor(totalSecs % 60)
    .toString()
    .padStart(2, "0");
  return `${m}:${s}`;
};

const AudioPlayer = ({ src = "", totalDuration = 0 }) => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(totalDuration || 0);

  useEffect(() => {
    setPlaying(false);
    setCurrentTime(0);
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  }, [src]);

  const onTimeUpdate = () => {
    setCurrentTime(audioRef.current?.currentTime || 0);
  };

  const onLoadedMetadata = () => {
    const dur = audioRef.current?.duration;
    if (dur && isFinite(dur)) setDuration(dur);
  };

  const onEnded = () => {
    setPlaying(false);
    setCurrentTime(0);
  };

  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setPlaying(p => !p);
  };

  const seek = e => {
    const bar = e.currentTarget;
    const rect = bar.getBoundingClientRect();
    const pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    const seekTo = pct * (duration || 1);
    if (audioRef.current) audioRef.current.currentTime = seekTo;
    setCurrentTime(seekTo);
  };

  const progressPct = duration > 0 ? (currentTime / duration) * 100 : 0;

  return (
    <div className="audioPlayer">
      <button className="audioPlayer__toggle" onClick={toggle}>
        <i className="material-icons">
          {playing ? "pause" : "play_arrow"}
        </i>
      </button>

      <div className="audioPlayer__track" onClick={seek}>
        <div
          className="audioPlayer__fill"
          style={{ width: `${progressPct}%` }}
        />
      </div>

      <span className="audioPlayer__time">
        {fmt(currentTime)} / {fmt(duration || totalDuration)}
      </span>

      <audio
        ref={audioRef}
        src={src}
        onTimeUpdate={onTimeUpdate}
        onLoadedMetadata={onLoadedMetadata}
        onEnded={onEnded}
      />
    </div>
  );
};

export default AudioPlayer;
